<template>

    <span >
        <div :disabled="loading" @click="signIn" class="google-btn" style="margin-left:-6px;position: relative; margin: 0px auto;">

        <div class="google-icon-wrapper">
            <img class="google-icon"
                 src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"/>
        </div>
        <p class="btn-text" ><b><span v-html="$t('googleSignIn.buttonText')"></span></b></p>
             <v-progress-circular
                     v-if="loading"
                     style="position:absolute;left:0;right:0;bottom:0;top:0;margin:auto;"
                     indeterminate
                     color="red"
             ></v-progress-circular>
    </div>

    </span>


</template>

    <style>

        .google-btn[disabled] {
            opacity:0.5;
            pointer-events: none;
        }

.google-btn {
    cursor: pointer;
    width: 234px;
    height: 42px;
    background-color: #4285f4;
    border-radius: 2px;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.google-btn .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: #fff;
}

.google-btn .google-icon {
    position: absolute;
    margin-top: 11px;
    margin-left: 11px;
    margin-right: 11px;
    width: 18px;
    height: 18px;
}

.google-btn .btn-text {
    position: absolute;
    margin: auto;
    left: 60px;
    right:0;
    top:11px;
    bottom: 0;


    color: #fff;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";

}

        .rtl .google-btn .btn-text {
            left: 0;
            right: 60px;
        }

.google-btn:hover {
    box-shadow: 0 0 6px #4285f4;
}

.google-btn:active {
    background: #1669F2;
}

</style>

<script>


import config from '../config'

export default {
    name: 'SignInButton',
    props: ['source'],
    data: ()=>({
        loading: false
    }),
    async created(){

        this.$gapi.constructor.prototype.currentGoogleUser = function() {
            return this._libraryInit('auth2')
                .then(auth => {
                    if (auth.isSignedIn.get()) {
                        return Promise.resolve(auth.currentUser.get())
                    } else {
                        return Promise.resolve(null)
                    }
                });
        };
    },
    methods: {
        async signInToBackend(authorizationDetails) {
            const response = await fetch(`${config.serverURL}/account/signin`, {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({idToken: authorizationDetails.idToken,
                  source: this.source,
                  affiliate : localStorage.affiliate || undefined,
                  referrer : localStorage.referrer || undefined
                })
            });

            return await response.json();
        },
        async signIn(){

            this.loading = true;
let user;
            try{
                await this.$gapi.signIn();
                user = await this.$gapi.currentGoogleUser();
            }catch(ex){

                this.loading = false;
                alert('Error: Failed to sign in, please try again or contact support.')
                throw ex;
            }

            //In case the user just close the window or not signed in, we simply disable the loader and break
            if(!user){
                this.loading = false;
                return;
            }

            if (user) {

                const idToken = user.getAuthResponse().id_token;
                this.customerEmail = user.getBasicProfile().getEmail();

                //I suspect that this request may fail from time to time because of google AppEngine, so We retry it in a second in case of fail
                try{
                    const {token, haveSubscription, name, picture, email, hadSubscription} = await this.signInToBackend({idToken});
                    this.$emit('completed', {token, haveSubscription, name, picture, email, hadSubscription});
                    this.loading = false;

                }catch(ex){

                    await new Promise(r=> setTimeout(r, 1000));

                    const {token, haveSubscription, name, picture, email, hadSubscription} = await this.signInToBackend({idToken});
                    this.$emit('completed', {token, haveSubscription, name, picture, email, hadSubscription});
                    this.loading = false;

                }


            }


        }

    }
};
</script>
